import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, ProductColumn, remoteLanguageFormatter, UnitFormatter} from "../../../utils/formatters";
import {postData, sendRequest} from "../../../utils/request";
import React, {Fragment, useState} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import isEqual from 'lodash-es/isEqual';
import Button from "../../form/Button";
import WriteOffForm from "./Elements/WriteOffForm";
import CheckBox from "../../form/CheckBox";
import TabContent from "../../layout/TabContent";
import Tabs from "../../layout/Tabs";
import {connect} from "react-redux";
import {setContent} from "../../../actions";
import Box from "../../layout/Box";
import ContentLoader from "../../layout/ContentLoader";
import {PriceView} from "../../classes/Price";

const sortable = true;
const filterable = true;

class WriteOffEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "AuthorsCopy",
        filter: [
            {column: "preset", value: "AuthorsCopy"},
            {column: "saved", value: 1}
        ],
        labels: {customer: "Partner"},
        actionButtons: [],
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            visible: false,
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "saleprice_net_total": {
                        field: "saleprice_net_total", type: "SUM"
                    },
                    "saleprice_gross_total": {
                        field: "saleprice_gross_total", type: "SUM"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "OperationProductPoolItem",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice_gross": {
                    header: 'Lista ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "stockqty": {
                    header: 'Raktárkészlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
        if (field === "customer" && !isEqual(value, this.props.values.customer)) {
            this.props.setFieldValue("target", null);
        }
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            componentEditor: this.props.token,
            filter: [
                {column: "preset", value: this.props.token},
                {column: "saved", value: 1}
            ],
            setFieldValue: this.setFieldValue,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Leírás
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.source) {
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = (props.values.customer || {}).partner_id || props.values.seller.partner_id;
        }
        if (props.values && props.values.source && (props.values.customer || (props.currentEditor === "FreeCopies" || props.componentEditor === "Damaged" || props.componentEditor === "Missing"))) {
            props.pool.visible = true;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [{field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [];
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={1} checked={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: !!value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <WriteOffForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

const WriteOffEditorFunc = (writeoff_type = "WriteOff") => createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: WriteOffEditor,
    editor: writeoff_type,
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = writeoff_type;
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});

let all_writeoff_types = {};
let all_writeoff_request = null;

const TabsHolder = (props) => <Tabs
    theme="default"
    className="modal-tabs"
    currentTab={(props.writeoffs[props.currentTab] || {}).token || undefined}
    onTabChange={(token) => {
        props.setCurrentTab(props.writeoffs.findIndex((i) => i.token + "" === "" + token));
        if (((props.editors[token] || {}).values || {}).id) {
            props.parentSetContent(props.currentEditor, {id: props.editors[token].values.id});
        } else {
            props.parentSetContent(props.currentEditor, {});
        }
    }}
>
    {props.writeoffs.map((writeoff) => {
        writeoff.token;
        const Label = remoteLanguageFormatter("WriteoffType")(writeoff.token);
        return <TabContent
            tabLabel={Label}
            tabName={writeoff.token}
        >
            <Fragment>{props.body}<div className="modal-footer with-footer">{props.footer}</div></Fragment>
        </TabContent>;
    })}
</Tabs>;

export const WriteOffEditorList = (editor) => {
    class WriteOffEditors extends React.Component {
        state = {
            currentTab: 0
        };

        componentDidMount() {
            const render = () => {
                this.writeoff_types = Object.keys(all_writeoff_types).map((writeoff) => {
                    if ((JSON.parse(all_writeoff_types[writeoff].xtradata) || {}).menuitem + "" === "" + editor) {
                        return {token: writeoff, editor: WriteOffEditorFunc(writeoff)};
                    }
                }).filter((o) => !!o).filter((w) => this.props.user.hasPermission(w.token));
                this.forceUpdate();
            };
            if (!Object.keys(all_writeoff_types).length) {
                if (!all_writeoff_request) {
                    all_writeoff_request = new Promise((resolve) => {
                        sendRequest({
                            option: "componentlist",
                            component: "option",
                            itemsperpage: 0,
                            optionname: "WriteoffType"
                        }).then(resolve);
                    });
                    all_writeoff_request.then((data) => {
                        const items = {};
                        ((data || {}).items || []).map((option) => {
                            items[option.token] = option;
                        });
                        all_writeoff_types = items;
                        render();
                    });
                } else {
                    all_writeoff_request.then(() => {
                        render();
                    })
                }
            } else {
                render();
            }
        }

        render() {
            if (!this.writeoff_types) return <ContentLoader />;
            const props = this.props;
            const currentTab = this.state.currentTab;
            const writeoffs = this.writeoff_types;
            if (!writeoffs.length) return <Box header="Hiba" theme="danger">
                Egyetlen leírás fajtához sincs jogod!
            </Box>;
            let Editor = writeoffs[currentTab].editor;
            if (((props.editors[writeoffs[currentTab].token] || {}).values || {}).id + "" !== "" + props.id) {
                if (((props.editors[writeoffs[currentTab].token] || {}).values || {}).id) {
                    props.setContent(editor, {id: props.editors[writeoffs[currentTab].token].values.id});
                } else {
                    props.setContent(editor, {});
                }
            }
            return <Editor id={props.id} editors={props.editors} token={writeoffs[currentTab].token} parentSetContent={(editor, props) => this.props.setContent(editor, props)} currentEditor={editor} writeoffs={writeoffs} currentTab={currentTab} setCurrentTab={(currentTab) => this.setState({currentTab})} editor={TabsHolder} />
        }
    }
    return connect((state) => {
        return {
            user: state.app.user,
            menu: state.app.template.menu,
            editors: state.editors
        }
    }, {setContent})(WriteOffEditors);
};

export default WriteOffEditorFunc;